import { defineMessages, injectIntl } from "react-intl";

import { connect } from "react-redux";

import { createSelector } from "reselect";

import { openModal } from "flavours/glitch/actions/modal";
import { logOut } from "flavours/glitch/utils/log_out";

import ColumnsArea from "../components/columns_area";

const messages = defineMessages({
  logoutMessage: { id: "confirmations.logout.message", defaultMessage: "Are you sure you want to log out?" },
  logoutConfirm: { id: "confirmations.logout.confirm", defaultMessage: "Log out" },
});

// Columns that work without a login. Everything else (compose, home, notifications...) needs an account.
const GUEST_COLUMNS = ["PUBLIC", "REMOTE", "COMMUNITY", "HASHTAG", "DIRECTORY"];

const getColumns = createSelector([
  state => state.getIn(["settings", "columns"]),
  state => !!state.getIn(["meta", "me"]),
], (columns, signedIn) => signedIn ? columns : columns.filter(column => GUEST_COLUMNS.includes(column.get("id"))));

const mapStateToProps = state => ({
  columns: getColumns(state),
});

const mapDispatchToProps = (dispatch, { intl }) => ({
  onLogout () {
    dispatch(openModal({
      modalType: "CONFIRM",
      modalProps: {
        message: intl.formatMessage(messages.logoutMessage),
        confirm: intl.formatMessage(messages.logoutConfirm),
        closeWhenConfirm: false,
        onConfirm: () => logOut(),
      },
    }));
  },
});

export default injectIntl(connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(ColumnsArea));
